import React from "react";
import { useTranslation } from "react-i18next";

import { legendItemStyle, legendStyle } from "./style";

// Palette contains in each row the maximum altitude, R,G,B color, and legend text

/*
The color map for LandScan USA is:
        1 - 2: light yellow  rgb(255,255,190)
       3 - 10: medium yellow rgb(255,255,115)
      11 - 25: yellow        rgb(255,255,0)
      26 - 50: orange        rgb(255,170,0)
     51 - 100: vermillion    rgb(230,76,0)
    101 - 250: red           rgb(230,0,0)
  251 - 35000: maroon        rgb(115,0,0)
*/

/*
# QGIS Generated Color Map Export File
INTERPOLATION:DISCRETE
0,0,0,0,0,0
2,255,255,190,255,1 - 2
10,255,255,115,255,3 - 10
25,255,255,0,255,11 - 25
50,255,170,0,255,26 - 50
100,230,76,0,255,51 - 100
250,230,0,0,255,101 - 250
35000,115,0,0,255,251 - 35000



*/

const palette = [
  [-1, 180, 180, 180, 255, "N/A"],
  [0, 255, 255, 255, 255, "0"],
  [2, 255, 255, 190, 255, "1 - 2"],
  [10, 255, 255, 115, 255, "3 - 10"],
  [25, 255, 255, 0, 255, "11 - 25"],
  [50, 255, 170, 0, 255, "26 - 50"],
  [100, 230, 76, 0, 255, "51 - 100"],
  [250, 230, 0, 0, 255, "101 - 250"],
  [35000, 115, 0, 0, 255, "251 - 35000"],
];

export const populationDensityUsaLegendColorList = palette.map(
  ([_val, r, g, b, _a, _txt]) => `rgb(${r}, ${g}, ${b})`,
);

export const PopulationDensityUsaLegend = ({ customLegendStyle = legendStyle }) => {
  const { t } = useTranslation();

  return (
    <div style={customLegendStyle}>
      <div>
        <b>{t("legend.populationDensityUsa")}</b>
      </div>

      {palette.map(([value, r, g, b, a, label]) => (
        <div key={value}>
          <span style={legendItemStyle(`rgba(${r}, ${g}, ${b}, ${a / 255})`)}></span>
          {label}
        </div>
      ))}

      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "xx-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          {t("riskExposureMapExplained.populationDensityUsa")}
        </span>
      </div>
    </div>
  );
};
